module.exports = __webpack_public_path__ + "img/10be139.jpg";